module.exports = __webpack_public_path__ + "static/img/gou.13b5f09d.svg";